/**
 * MacroBaby — Language switcher PT-BR / EN.
 * Adiciona links de troca de idioma no header (desktop) e na announcement bar (mobile).
 * Depende de: jQuery (apenas porque é executado dentro de $(document).ready no contexto original)
 */
(function () {
    document.addEventListener("DOMContentLoaded", function () {
        const PT_URL = "https://www.br.macrobaby.com/pages/macrobaby-brasil";
        const EN_URL = "https://www.macrobaby.com/";

        const ptImg = "https://cdn.shopify.com/s/files/1/0325/7932/1915/files/pt.webp?v=1677516565";
        const enImg = "https://cdn.shopify.com/s/files/1/0325/7932/1915/files/en.webp?v=1677516565";

        // Mantém o href das bandeiras fixo caso algum script de terceiro o reescreva.
        // Só escreve quando o valor difere, para não disparar mutações em loop
        // (o antigo setInterval de 100ms custava ~12s de CPU no Lighthouse mobile).
        function lockHref(wrapper, ptHref, enHref) {
            const fix = () => {
                const pt = wrapper.querySelector(".idioma-pt a");
                const en = wrapper.querySelector(".idioma-en a");
                if (pt && pt.getAttribute("href") !== ptHref) pt.setAttribute("href", ptHref);
                if (en && en.getAttribute("href") !== enHref) en.setAttribute("href", enHref);
            };
            fix();
            new MutationObserver(fix).observe(wrapper, { subtree: true, childList: true, attributes: true, attributeFilter: ["href"] });
        }

        // Em domínio BR, redireciona o logo para a landing BR
        if ("www.br.macrobaby.com" === window.location.host) {
            const logo = document.querySelector(".header__logo-link");
            if (logo) logo.href = "/pages/macrobaby-brasil";
        }

        // Desktop (>= 979px): injeta no header
        if (window.innerWidth >= 979) {
            const headerInner = document.querySelector(".header__inner");
            if (headerInner) {
                const wrapper = document.createElement("div");
                wrapper.className = "idioma";
                wrapper.innerHTML = `
                    <span class="idioma-pt"><a href="${PT_URL}" target="_self" aria-label="Alternar para português"><img src="${ptImg}" width="25" height="25" title="Português" alt="Português"></a></span>
                    <span class="idioma-en"><a href="${EN_URL}" target="_self" aria-label="Switch to English"><img src="${enImg}" width="25" height="25" title="Inglês" alt="Inglês"></a></span>
                `;
                const cartItem = headerInner.querySelector(".header__action-item--cart");
                if (cartItem) {
                    cartItem.insertAdjacentElement("afterend", wrapper);
                } else {
                    headerInner.appendChild(wrapper);
                }
                lockHref(wrapper, PT_URL, "https://www.macrobaby.com");
            }
        }

        // Mobile (<= 640px): injeta ao lado do carrinho no header
        if (window.innerWidth <= 640) {
            const cartItem = document.querySelector(".header__action-item--cart");
            if (cartItem) {
                cartItem.insertAdjacentHTML("beforebegin", `
                    <div class="idioma">
                        <span class="idioma-pt"><a href="${PT_URL}" target="_self" aria-label="Alternar para português"><img src="${ptImg}" width="25" height="25" title="Português" alt="Português"></a></span>
                        <span class="idioma-en"><a href="${EN_URL}" target="_self" aria-label="Switch to English"><img src="${enImg}" width="25" height="25" title="Inglês" alt="Inglês"></a></span>
                    </div>
                `);
                const wrapper = cartItem.previousElementSibling;
                if (wrapper && wrapper.classList.contains("idioma")) lockHref(wrapper, PT_URL, EN_URL);
            }

            // Slick slider para .linksCustomers (mobile only — dependeu do bundle Warehouse)
            const links = document.querySelector(".linksCustomers ul");
            if (links) {
                links.classList.add("slick-slider");
                links.setAttribute("data-slick", '{ "infinite": true, "slidesToShow": 3, "slidesToScroll": 3 }');
            }
        }
    });
})();
